import EdoAdhocReporting from './EdoAdhocReporting';

export default EdoAdhocReporting;
